import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

export const VEHICLE_VALUATION_SNAPSHOT_OPERATION = "snapshot" as const;
export const VEHICLE_VALUATION_SNAPSHOT_API_PATH = "/v1/vehicle-valuation/{uuid}/snapshot" as const;

export type VehicleValuationSnapshotResponse =
  paths[typeof VEHICLE_VALUATION_SNAPSHOT_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationSnapshotQuery(uuid: string, options?: { enabled?: boolean }) {
  return useQuery<VehicleValuationSnapshotResponse, AxiosError>({
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    queryKey: [VEHICLE_VALUATION_RESOURCE, uuid, VEHICLE_VALUATION_SNAPSHOT_OPERATION],
    queryFn: async () => {
      const apiPath = VEHICLE_VALUATION_SNAPSHOT_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.get<VehicleValuationSnapshotResponse>(apiPath);

      return response.data;
    },
    retry: (failureCount, error) => error.response?.status !== 404 && failureCount < 2,
  });
}
